<script lang="ts">
  import type { System } from './+page.svelte';

  let { system, activeOnly }: { system: System; activeOnly: boolean } = $props();
</script>

<table class="table-zebra no-grid table">
  <thead>
    <tr>
      <th>
        <span class="text-info">Pool</span>
        &gt;
        <span class="text-primary">Parity group</span>
      </th>
      <th>Internal ID</th>
      <th>Tier</th>
      {#if !activeOnly}
        <th>Active</th>
      {/if}
    </tr>
  </thead>
  <tbody class="text-xs!">
    {#each system.hpDetails!.pools.filter((p) => p.active || !activeOnly) as pool}
      <tr>
        <td class="text-info text-lg font-bold">{pool.name}</td>
        <td>{pool.internalId ?? '-'}</td>
        <td>{typeof pool.tier === 'number' ? `T${pool.tier}` : '-'}</td>
        {#if !activeOnly}
          <td class="text-center!">
            <input
              type="checkbox"
              class="checkbox checkbox-xs checkbox-primary cursor-default"
              checked={pool.active}
              readonly
              onclick={(e) => e.preventDefault()}
            />
          </td>
        {/if}
      </tr>
      {#each pool.parityGroups as pg}
        <tr>
          <td>
            <span class="text-primary pl-4 font-semibold">{pg.name}</span>
          </td>
          <td></td>
          <td></td>
        </tr>
      {/each}
    {/each}
  </tbody>
</table>

<style>
  td:nth-child(2),
  td:nth-child(3) {
    text-align: center;
    place-content: center;
  }
</style>
